import React from 'react';
import { useTranslation } from 'react-i18next';

function AboutUsPage({ aboutUsContent }) {
    const { t } = useTranslation();

    const content = aboutUsContent || {};
    const teamMembers = content.teamMembers || [];
    const coreAdvantages = content.coreAdvantages || [];

    return (
        <section id="about" className="py-16 md:py-24 bg-white rounded-lg shadow-md m-4">
            <div className="container mx-auto px-4 md:px-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-10 section-title">{t('about_us')}</h2>

                {/* About Us Introduction */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-16">
                    <div className="md:order-2">
                        <img
                            src={content.aboutImageUrl || 'https://placehold.co/600x400/add8e6/000000?text=About+Us+Image'}
                            alt={t('about_us')}
                            className="rounded-lg shadow-lg w-full h-auto object-cover"
                            onError={(e) => e.target.src = 'https://placehold.co/600x400/cccccc/333333?text=Image+Error'}
                        />
                    </div>
                    <div className="md:order-1">
                        <p className="text-lg text-gray-700 leading-relaxed mb-4">
                            {content.aboutText1}
                        </p>
                        <p className="text-lg text-gray-700 leading-relaxed">
                            {content.aboutText2}
                        </p>
                    </div>
                </div>

                {/* Team Section */}
                <div className="mb-16">
                    <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">{t('admin_about_us_team_members_title')}</h3>
                    <p className="text-center text-lg text-gray-700 mb-10">{content.teamIntro}</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {teamMembers.map((member, index) => (
                            <div key={index} className="flex flex-col items-center text-center bg-gray-50 p-6 rounded-lg shadow-md">
                                <img
                                    src={member.imageUrl || 'https://placehold.co/150x150/a7d9ff/007bff?text=Member'}
                                    alt={member.name}
                                    className="w-32 h-32 rounded-full object-cover mb-4 border-4 border-blue-200"
                                    onError={(e) => e.target.src = 'https://placehold.co/150x150/cccccc/333333?text=Image+Error'}
                                />
                                <h4 className="text-xl font-semibold text-gray-800 mb-1">{member.name}</h4>
                                <p className="text-blue-600 font-medium mb-2">{member.title}</p>
                                <p className="text-gray-600 text-sm">{member.bio}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Core Advantages Section */}
                <div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">{t('admin_about_us_core_advantages_title')}</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {coreAdvantages.map((advantage, index) => (
                            <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md">
                                <h4 className="text-xl font-semibold text-gray-800 mb-3">{advantage.title}</h4>
                                <ul className="list-disc list-inside text-gray-700 space-y-1">
                                    {(advantage.points || []).map((point, pIndex) => (
                                        <li key={pIndex}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutUsPage;
